import React from 'react';
import styles from './StudyListExtractionMessage.module.scss';
import {
  Text,
  Message,
  IconList,
  MessageControls,
  Button,
  Heading,
} from 'components/core';

export type StudyListExtractionMessageProps = {
  studiesInExtraction: number;
  extractionHelpUrl?: string;
  startExtractionUrl: string;
  deType: 'de1' | 'de2';
};

const acknowledgementKey = 'de-hide-extraction-prompt';
const acknowledgedValue = '1';

const getAcknowledgementState = () => {
  return sessionStorage.getItem(acknowledgementKey);
};

const setAcknowledgementState = () => {
  sessionStorage.setItem(acknowledgementKey, acknowledgedValue);
};

const StudyListExtractionMessage = ({
  studiesInExtraction,
  extractionHelpUrl,
  startExtractionUrl,
  deType,
}: StudyListExtractionMessageProps) => {
  const showMessage =
    studiesInExtraction > 0 && getAcknowledgementState() != acknowledgedValue;

  const messageHeadingText = `Ready to extract data from ${studiesInExtraction} ${
    studiesInExtraction > 1 ? 'studies' : 'study'
  }?`;

  const message =
    deType === 'de1'
      ? `Use our Extraction 1 tool, designed around the PICO framework to
      guide extraction. It increases accuracy and consistency for ease of
      meta-analysis.`
      : `Use our Extraction 2 tool, designed to be fully customisable to suit any review type.`;

  const hideMessage = () => {
    setAcknowledgementState();
  };

  return (
    <>
      {showMessage && (
        <Message onClose={hideMessage} icon={IconList.solid.faFiles}>
          <Heading type="h5" className={styles.heading}>
            {messageHeadingText}
          </Heading>
          <Text>{message}</Text>
          <MessageControls className={styles.wrap}>
            <Button type="brand" to={startExtractionUrl}>
              Start extraction
            </Button>
            {extractionHelpUrl && (
              <Button variant="ghost" to={extractionHelpUrl} target={'_blank'}>
                Learn more
              </Button>
            )}
          </MessageControls>
        </Message>
      )}
    </>
  );
};

export default StudyListExtractionMessage;
